import type {BdCondition} from '../conditions/condition';
import {BdConjunctionCondition} from './conjunction-condition';

export const BD_AND_CONDITION_ID = 'and';

export class BdAndCondition extends BdConjunctionCondition {

    constructor(
        conditions: BdCondition[] = []
    ) {
        super(BD_AND_CONDITION_ID, conditions);
    }
}
